import annotation from "./assets/annotation.svg"
import close from "./assets/close.svg"
import remove from "./assets/delete.svg"
import down from "./assets/down.svg"
import headline from "./assets/headline.svg"
import image from "./assets/image.svg"
import quotation from "./assets/quotation.svg"
import survey from "./assets/survey.svg"
import up from "./assets/up.svg"

export enum AddType {
  ANNOTATION,
  HEADLINE,
  IMAGE,
  QUOTATION,
  SURVEY,
  REMOVE,
  UP,
  DOWN,
  CLOSE,
}

export const addCommands = [
  {
    img: annotation,
    type: AddType.ANNOTATION,
  },
  {
    img: headline,
    type: AddType.HEADLINE,
  },
  {
    img: image,
    type: AddType.IMAGE,
  },
  {
    img: quotation,
    type: AddType.QUOTATION,
  },
  {
    img: survey,
    type: AddType.SURVEY,
  },
  {
    img: remove,
    type: AddType.REMOVE,
  },
  {
    img: up,
    type: AddType.UP,
  },
  {
    img: down,
    type: AddType.DOWN,
  },
  {
    img: close,
    type: AddType.CLOSE,
  },
]
